import React from 'react';
import { BarChartIcon, UsersIcon, ClipboardListIcon } from 'lucide-react';
interface TherapistsSectionProps {
  onOpenWaitlist: () => void;
}
export const TherapistsSection: React.FC<TherapistsSectionProps> = ({
  onOpenWaitlist
}) => {
  return <section id="therapists" className="py-16 md:py-24" data-id="element-276">
      <div className="section-container" data-id="element-277">
        <div className="text-center mb-12" data-id="element-278">
          <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper mb-4" data-id="element-279">
            Empowering therapists to deliver precision care.
          </h2>
          <p className="text-lg text-plum-gray max-w-2xl mx-auto" data-id="element-280">
            Our therapist tools combine AI insights with intuitive dashboards,
            enabling personalized treatment delivery and continuous learning.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-282">
            <div className="w-14 h-14 rounded-full bg-mint-sage/30 flex items-center justify-center mb-4" data-id="element-283">
              <BarChartIcon className="text-deep-juniper" size={28} data-id="element-284" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-285">
              Data-Driven Insights
            </h3>
            <p className="text-plum-gray" data-id="element-286">
              Access clear visualizations of client progress, helping you
              identify patterns and adapt treatment approaches.
            </p>
          </div>
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-287">
            <div className="w-14 h-14 rounded-full bg-sandstone/50 flex items-center justify-center mb-4" data-id="element-288">
              <UsersIcon className="text-deep-juniper" size={28} data-id="element-289" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-290">
              Personalized Matches
            </h3>
            <p className="text-plum-gray" data-id="element-291">
              Our system connects you with clients who align with your
              expertise, creating more effective therapeutic relationships.
            </p>
          </div>
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-292">
            <div className="w-14 h-14 rounded-full bg-apricot/30 flex items-center justify-center mb-4" data-id="element-293">
              <ClipboardListIcon className="text-deep-juniper" size={28} data-id="element-294" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-295">
              Structured Tools
            </h3>
            <p className="text-plum-gray" data-id="element-296">
              Access evidence-based protocols and resources to support your
              clinical work, all integrated into one intuitive platform.
            </p>
          </div>
        </div>
        <div className="text-center mt-12" data-id="element-297">
          <button onClick={onOpenWaitlist} className="btn-secondary" data-id="element-298">
            Are you a therapist interested in Re:Joy? →
          </button>
        </div>
      </div>
    </section>;
};